<div class="container">
  <div class="header">
    <c-icon [icon]="faCloudArrowUp" color="primary" size="xl"></c-icon>
    <div>{{ title | transloco }}</div>
  </div>
  <div class="description">
    {{ description | transloco }}
  </div>
  <ion-footer class="ion-no-border">
    <ion-toolbar>
      <div class="buttons flex-column gap-8">
        <c-button
          (action)="takePicture()"
          [icon]="faCamera"
          iconPosition="start"
          data-test-id="c-photo-option-picker-component.take-picture.button">
          {{ 'common.take-picture' | transloco }}
        </c-button>
        <c-button
          (action)="fromPhotos()"
          [icon]="faCloudArrowUp"
          iconPosition="start"
          data-test-id="c-photo-option-picker-component.from-photos.button">
          {{ 'common.from-photos' | transloco }}
        </c-button>
        <c-button
          type="secondary"
          (action)="close(null)"
          data-test-id="c-photo-option-picker-component.cancel.button">
          {{ 'my-work.cancel' | transloco }}
        </c-button>
      </div>
    </ion-toolbar>
  </ion-footer>
</div>
